import React from 'react';

import styles from './ActionLoader.module.css';

export default function ActionLoader({ isLoading }: { readonly isLoading: boolean }) {
    return isLoading && <div className={styles.loader} />;
}
